import clsx from 'clsx'
import Link from 'next/link'
import { useRouter } from 'next/router'
import type { FunctionComponent } from 'react'
import { InternalLink } from '../../const/Links'
import { useTranslate } from '../../contexts/TranslationContext'
import SvgGranlupoLogo from '../../svg/icons/GranlupoLogo'
import style from './Logo.module.sass'

type LogoProps = {
	small?: boolean
}

export const Logo: FunctionComponent<LogoProps> = ({ small = false }) => {
	const translate = useTranslate()

	const router = useRouter()

	return (
		<>
			{router.asPath === InternalLink.Home ? (
				<div title={translate('logo.ariaLabel')} className={clsx(style.logoWrapper, small && style.logoWrapperSmall)}>
					<SvgGranlupoLogo />
				</div>
			) : (
				<Link
					href={InternalLink.Home}
					aria-label={translate('logo.ariaLabel')}
					title={translate('logo.ariaLabel')}
					className={clsx(style.logoWrapper, small && style.logoWrapperSmall)}
				>
					<SvgGranlupoLogo />
				</Link>
			)}
		</>
	)
}
